import TemplateBodyField from '../components/template-body-field';
import styles from '../stylesheets/utilityCallPermission.module.css';

const UtilityCallPermissionTemplate = ({
  control,
  watch,

  textAreaRef,
  getFormErrorMessage,

  SPAM_SUGGESTIONS,
  showSpamSuggestions,
  setShowSpamSuggestions,
  checkForSpam,

  messsageVariables,
  menuRef,

  showEmoji,
  setShowEmoji,
  handleEmojiClick,

  tempVariables,
  handleEditVariable,
  handleDeleteVariable,
  watchContent,
}) => {
  return (
    <>
      {/* Body */}

      <TemplateBodyField
        control={control}
        textAreaRef={textAreaRef}
        getFormErrorMessage={getFormErrorMessage}
        SPAM_SUGGESTIONS={SPAM_SUGGESTIONS}
        showSpamSuggestions={showSpamSuggestions}
        setShowSpamSuggestions={setShowSpamSuggestions}
        checkForSpam={checkForSpam}
        messsageVariables={messsageVariables}
        menuRef={menuRef}
        showEmoji={showEmoji}
        setShowEmoji={setShowEmoji}
        handleEmojiClick={handleEmojiClick}
        tempVariables={tempVariables}
        handleEditVariable={handleEditVariable}
        handleDeleteVariable={handleDeleteVariable}
        watchContent={watchContent}
      />

      {/* Permission Card */}
      <div className={styles.permissionWrapper}>
        {/* HEADER */}
        <div className={styles.permissionHeader}>
          <span className={styles.permissionTitle}>Permission Card</span>
          <span className={styles.permissionTitle}>[System Generated]</span>
        </div>

        {/* CARD */}
        <div className={styles.permissionCard}>
          {/* TOP SECTION */}
          <div className={styles.topSection}>
            <div className={styles.iconCircle}>
              <i className="pi pi-phone" />
            </div>

            <div>
              <div className={styles.question}>
                Can <span style={{ color: '#005068' }}>[Business Name]</span> call you?
              </div>

              <div className={styles.subText}>Pulled from your WhatsApp Business profile</div>
            </div>
          </div>

          {/* DIVIDER */}
          <div className={styles.divider} />

          {/* PREFERENCES */}
          <div className={styles.preferenceSection}>
            <div className={styles.preferenceToggle}>
              Choose Preferences <i className="pi pi-chevron-down" />
            </div>

            <div className={styles.divider} />

            {/* CUSTOMER CHOICES */}
            <div className={styles.choiceWrapper}>
              <div className={styles.choiceLabel}>Customer Choices:</div>

              <div className={styles.choices}>
                <span className={`${styles.choice} ${styles.allow}`}>✔ Allow</span>

                <span className={`${styles.choice} ${styles.deny}`}>✖ Don't Allow</span>

                <span className={styles.choice}>⏰ Remind Me</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UtilityCallPermissionTemplate;
